import { WorkflowApplication } from './workflow-application';
import { InspectionAddress } from './address';
import { InspectionDocument } from './inspection-document';
import { MapExtent } from './mapextent';

export class InspectionStatusDict {
  PendingSchedule = <any>'Pending Schedule';
  PendingInspection = <any>'Pending Inspection';
  Approved = <any>'Approved';
  Denied = <any>'Denied';
  Deleted = <any>'Deleted';
  Voided = <any>'Voided';
  Requested = <any>'Requested';
  Scheduled = <any>'Scheduled';
  AppointmentCanceled = <any>'Appointment Canceled';
  Bypassed = <any>'Bypassed';

  constructor(options?: Partial<PagedInspectionsVM>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export enum InspectionStatus {
  PendingSchedule,
  PendingInspection,
  Approved,
  Denied,
  Deleted,
  Voided,
  Requested,
  Scheduled,
  AppointmentCanceled,
  Bypassed,
  Needed
}

export enum InspectionRequestTod {
  AM,
  PM,
  Unset
}

export class PagedInspectionsVM {
  recordCount: number;
  pageCount: number;
  unpermissibleCount: number;
  inspections: InspectionVM[];

  constructor(options?: Partial<PagedInspectionsVM>) {
    this.inspections = [new InspectionVM()];

    if (options) {
      Object.assign(this, options);
    }
  }
}

export class InspectionVM {
  permitNumber: string;
  id: string;
  inspectorId?: string;
  status: InspectionStatus;
  reqTOD: InspectionRequestTod;
  workflowApplicationId: string;
  createdOn: Date;
  createdBy: string;
  modifiedOn: Date;
  inspectionType: string;
  documents?: InspectionDocument[];
  workflowApplicationActivityDataId: string;
  activityName?: string;
  requestorName: string;
  requestorPhoneNumber: string;
  requestorAddress: InspectionAddress;
  requestorAddress_Id: string;
  requestedOn: string;
  notes: any[];
  customFields: any[];

  scheduledOn?: Date;
  scheduledOnIncludesTime?: boolean;
  completedOn?: Date;
  modifiedBy: string;
  requestorEmail?: string;

  inspectorName?: string;
  canCompleteInspection: boolean;
  canScheduleInspection: boolean;
  canViewDetailsActivity: boolean;
  geometryWkts: string[];
  clientId: string;
  parcelId: string;
  applicationName: string;
  workflowApplication: WorkflowApplication;

  noSchedule: boolean;
  downloadedToTabletOn?: Date;
  uploadedFromTabletOn?: Date;

  constructor(options?: Partial<InspectionVM>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class InspectionVMJanus {
  inspectionId: string;
  inspectionApplicationId: string;
  status: InspectionStatus;
  scheduledOnString?: string;
  scheduledTimeString?: string;
  requestorName: string;
  requestorPhoneNumber: string;
  requestorAddress: InspectionAddress;
  requestorEmail?: string;
  noSchedule: boolean;
  canScheduleInspection: boolean;
  canCompleteInspection: boolean;
  linkedApplicationId?: string;
  notes: InspectionNote[];
  customFields: any[];
  documents: InspectionDocument[];

  constructor(options?: Partial<InspectionVMJanus>) {
    this.notes = [];
    this.customFields = [];
    this.documents = [];

    if (options) {
      Object.assign(this, options);
    }
  }
}

export class InspectionListItemJanus {
  inspectionId: string;
  geometryWkts: string[];

  // Visible columns - filter keys documented in comments
  inspectionApplicationNumber: string;  // Filter key: "inspectionAppNumber"
  applicationNumber: string;             // Filter key: "appNumber"
  applicantName: string;                 // Filter key: "applicantName"
  applicationType: string;               // Filter key: "workflowName"
  applicationCreatedOnDate: string;      // Filter key: "appCreatedOn"
  applicantPhoneNumber: string;          // Filter key: "applicantPhone"
  parcelID: string;                      // Filter key: "parcelId"
  inspectionCompletedOnDate: string;     // Filter key: "inspectionCompletedOn"
  inspectorName: string;                 // Filter key: "inspectorId"
  inspectionType: string;                // Filter key: "inspectionType"
  inspectionStatus: string;              // Filter key: "inspectionStatus"
  applicationDescription: string;        // Filter key: "appDescription"
  requestedOnDate: string;               // Filter key: "requestedOn"
  scheduledOnDate: string;               // Filter key: "scheduledOn" (date portion, client-local)
  scheduledOnTime: string;               // Time portion, client-local; null when ScheduledOnIncludesTime is not true
  address: string;                       // Filter key: "address"
  city: string;                          // Filter key: "city"

  constructor(options?: Partial<InspectionListItemJanus>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class SearchInspectionsJanusRequest {
  clientId: string;
  departmentId?: string;
  additionalFilters: any[];
  sortField: string;
  sortDescending: boolean;
  pageNumber: number;
  pageSize: number;
  extent: MapExtent;

  constructor(options?: Partial<SearchInspectionsJanusRequest>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class ExportInspectionsJanusRequest {
  clientId: string;
  departmentId?: string;
  additionalFilters: any[];
  useExcelFormat: boolean;
  exportColumns: string[];
  extent: MapExtent;

  constructor(options?: Partial<ExportInspectionsJanusRequest>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class SearchInspectionsJanusResponse {
  recordCount: number;
  pageCount: number;
  pageSize: number;
  unpermissibleCount: number;
  inspections: InspectionListItemJanus[];

  constructor(options?: Partial<SearchInspectionsJanusResponse>) {
    this.inspections = [];

    if (options) {
      Object.assign(this, options);
    }
  }
}

export class InspectionNote {
  id: string;
  type: InspectionNoteType;
  value: string;
  inspectionId: string;
  modifiedBy: string;
  modifiedOnString: string;
  workflowApplicationActivityDataId?: string;

  constructor(options?: Partial<InspectionNote>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export enum InspectionNoteType {
    General,
    Request,
    Decision,
    RescheduleReason,
    CancelReason,
    BypassReason
}
